module.exports = __webpack_public_path__ + "static/media/terrace-3.0a94d3d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/terrace-3.jpg
// module id = 302
// module chunks = 0